export const urls = {
    login: '/',
    home: '/main',
    getArticleById: 'api/Articles/GetViewModelForEditById',
    createArticle: 'api/Articles/CreateArticle',
    updateArticle: 'api/Articles/UpdateArticle',
    uploadTitleImageArticle: 'api/FileUpload/UploadTitleImageArticle',
    articles: '/admin/articles',
    deleteArticle: 'api/Articles/DeleteArticle',
    loadArticles: 'api/Articles/LoadArticles',
    loadPublishedArticles: 'api/Articles/LoadPublishedArticles',
    deleteContact: 'api/Contacts/DeleteContact',
    loadContacts: 'api/Contacts/LoadContacts',
    loadPublishedContacts: 'api/Contacts/LoadPublishedContacts',
    getContactById: 'api/Contacts/GetViewModelForEditById',
    contactsRubric: 'api/Rubric/GetRubricsByEntityKey?key=Contact',
    newsRubric: 'api/Rubric/GetRubricsByEntityKey?key=News',
    saveContact: 'api/Contacts/SaveContact',
    updateContact: 'api/Contacts/UpdateContact',
    createContact: 'api/Contacts/CreateContact',
    contacts: '/admin/contacts',
    uploadTitleImageContact: 'api/FileUpload/UploadTitleImageContact',
    getResourceById: 'api/Resources/GetViewModelForEditById',
    resourcesRubric: 'api/Rubric/GetRubricsByEntityKey?key=Resource',
    updateResource: 'api/Resources/UpdateResource',
    createResource: 'api/Resources/CreateResource',
    getRubrics: 'api/Rubric/GetRubrics',
    getRubricsForSubcategories:'api/Rubric/GetRubricForSubcategories',
    saveResource: 'api/Resources/SaveResource',
    links: '/admin/links',
    uploadFilesLink: 'api/FileUpload/UploadFilesLink',
    deleteResource: 'api/Resources/DeleteResource',
    loadResources: 'api/Resources/LoadResources',
    loadPublishedResources: 'api/Resources/LoadPublishedResources',
    news: '/admin',
    deleteNews: 'api/News/DeleteNews',
    loadNews: 'api/News/LoadNews',
    getNewsById: 'api/News/GetViewModelForEditById',
    updateNews: 'api/News/UpdateNews',
    createNews: 'api/News/CreateNews',
    uploadTitleImageNews: 'api/FileUpload/UploadTitleImageNews',
    loadUsers: 'api/User/LoadUsers',
    saveGroupsUser: 'api/User/SaveGroupsUser',
    getGroupPermissionsList: 'api/GroupPermission/GetGroupPermissionsList',
    loadRoles: 'api/Role/LoadRoles',
    getPermissionObjects: 'api/ObjectPermission/GetPermissionObjects',
    updateObjectsRole: 'api/Role/Update',
    getRoleList: 'api/Role/GetRoleList',
    loadGroupPermissionsList: 'api/GroupPermission/LoadGroupPermissionsList',
    getUsersList: 'api/User/GetUsersList',
    getAllActiveUsers: 'api/User/GetAllActiveUsers',
    updatePermissionsList: 'api/GroupPermission/UpdatePermissionsList',
    groupPermissionRemoveAt: 'api/GroupPermission/RemoveAt',
    createGroupPermission: 'api/GroupPermission/Create',
    updateGroupPermission: 'api/GroupPermission/Update',
    permissions: '/admin/permissions',
    getFullCurrentUser: 'api/User/GetFullCurrentUser',
    getChatGroupsByUserId: 'api/Chat/GetChatGroupsByUserId',
    getUsersGroup: 'api/Chat/GetUsersGroup',
    getChatMessages: 'api/Chat/GetChatMessages',
    getSearchMessages: 'api/Chat/GetSearchMessages',
    loadPublishedNews: 'api/News/LoadPublishedNews',
    getShortLombardAuction: 'api/Auction/GetShortLombardAuction',
    getShortLombardAuctionFilter: 'api/Auction/GetShortLombardAuctionFilter',
    getDepositAuction: 'api/Auction/GetDepositAuction',
    getDepositAuctionFilter: 'api/Auction/GetDepositAuctionFilter',
    getSWAPAuction: 'api/Auction/GetSWAPAuction',
    getSWAPAuctionFilter: 'api/Auction/GetSWAPAuctionFilter',
    getREPOAuction: 'api/Auction/GetREPOAuction',
    getREPOAuctionFilter: 'api/Auction/GetREPOAuctionFilter',
    getREPOReverseAuction: 'api/Auction/GetREPOReverseAuction',
    getREPOReverseAuctionFilter: 'api/Auction/GetREPOReverseAuctionFilter',
    getDepositAuctionArchive: 'api/File/GetDepositAuctionArchive',
    getShortLombardAuctionArchive: 'api/File/GetShortLombardAuctionArchive',
    getSWAPAuctionArchive: 'api/File/GetSWAPAuctionArchive',
    getFileREPOAuctions: 'api/File/GetFileREPOAuctions',
    getFileREPOReverceAuctions: 'api/File/GetFileREPOReverceAuctions',
    getFileTransferAuctionsByFileName: 'api/File/GetFileTransferAuctionsByFileName',
    getBondPlacementAuctionBel: 'api/Auction/GetBondPlacementAuctionBel',
    getBondPlacementAuctionForeign: 'api/Auction/GetBondPlacementAuctionForeign',
    getBondPlacementAuctionBelFilter: 'api/Auction/GetBondPlacementAuctionBelFilter',
    getBondPlacementAuctionForeignFilter: 'api/Auction/GetBondPlacementAuctionForeignFilter',
    getFileBondPlacementBel: 'api/File/GetFileBondPlacementBel',
    getFileBondPlacementForeign: 'api/File/GetFileBondPlacementForeign',
    getFileByPath: 'api/File/GetFileByPath',
    getFileContentByPath: 'api/File/GetFileContentByPath',
    getContentByPath: 'api/File/GetContentByPath',
    getPdfFile: 'api/File/ViewPdf',
    directories: '/admin/directories',
    getAllDirectoryFunction: 'api/DirectoryFunction/GetAll',
    createDirectoryFunction: 'api/DirectoryFunction/Create',
    updateDirectoryFunction: 'api/DirectoryFunction/Update',
    removeDirectoryFunction: 'api/DirectoryFunction/Remove',
    getAllDirectoryOrganization: 'api/DirectoryOrganization/GetAll',
    createDirectoryOrganization: 'api/DirectoryOrganization/Create',
    updateDirectoryOrganization: 'api/DirectoryOrganization/Update',
    removeDirectoryOrganization: 'api/DirectoryOrganization/Remove',
    isUniqueTIN: 'api/DirectoryOrganization/IsUniqueTIN',
    isUniqueFunctionTitle: 'api/DirectoryFunction/IsUniqueFunctionTitle',
    isUniqueSubdivisionTitle: 'api/DirectorySubdivision/IsUniqueSubdivisionTitle',
    getDirectorySubcategoryByRubricId: 'api/DirectorySubcategory/GetAllByRubricId',
    createDirectorySubcategory: 'api/DirectorySubcategory/Create',
    updateDirectorySubcategory: 'api/DirectorySubcategory/Update',
    removeDirectorySubcategory: 'api/DirectorySubcategory/Remove',
    getAllDirectorySubdivision: 'api/DirectorySubdivision/GetAll',
    createDirectorySubdivision: 'api/DirectorySubdivision/Create',
    updateDirectorySubdivision: 'api/DirectorySubdivision/Update',
    removeDirectorySubdivision: 'api/DirectorySubdivision/Remove',
    urlApplicationConfig: '/api/File/GetUrlApplicationConfig',
    getLiveApplications: 'api/Application/GetLiveApplications',
    newsClient: '/main/news',
    messagesClient: '/main/messages',
    getEditorUploadFileNews: 'api/FileUpload/UploadFileEditorNews',
    getEditorUploadFileArticles: 'api/FileUpload/UploadFileEditorArticles',
    chatHubUrl: '/chatHub',
    newsHubUrl: '/newsHub',
    getDataForTransactionRates: 'api/Rates/GetDataForTransactionRates',
    getNBRBRatesArchive: 'api/File/GetNBRBRatesArchive',
    getDataForListDocuments: 'api/Rates/GetDataForListDocuments',
    getCurrencyCoeficient: 'api/Rates/GetCurrencyCoeficient',
    getScheduleAuctionPage: 'api/ScheduleOperation/GetScheduleAuctionPage',
    getTimeLimitPage: 'api/ScheduleOperation/GetTimeLimitPage',
    getSheduleBasicOperationPage: 'api/ScheduleOperation/GetSheduleBasicOperationPage',
    getSWAPHolidaysData: 'api/ScheduleOperation/GetSWAPHolidaysData',
    getChatIdForGroup: 'api/Chat/GetChatIdForGroup',
    getUserForAddToGroup: 'api/Chat/GetUserForAddToGroup',
    getUserInGroupForEdit: 'api/Chat/GetUserInGroupForEdit',
    saveEditChatGroup: 'api/Chat/SaveGroup',
    removeChatGroup: 'api/Chat/RemoveGroup',
    uploadFileChat: 'api/FileUpload/UploadFileChat',
    uploadEmptyFileChat: 'api/FileUpload/UploadEmptyFileChat',
    getCountMessageCurrentUser: '/api/Chat/GetCountMessageCurrentUser',
    updateShowStatusMessages: '/api/Chat/UpdateShowStatusMessages',
    getSearchMatchesCount: '/api/Chat/GetSearchMatchesCount',
    getForeignAuction: 'api/PlannedOperation/GetForeignAuction',
    getForeignAddPlacement: 'api/PlannedOperation/GetForeignAddPlacement',
    getForeignPrivateSale: 'api/PlannedOperation/GetForeignPrivateSale',
    getBelAddPlacement: 'api/PlannedOperation/GetBelAddPlacement',
    getBelAuction: 'api/PlannedOperation/GetBelAuction',
    getBelPrivateSale: 'api/PlannedOperation/GetBelPrivateSale',
    getNbrbPlannedOperations: 'api/PlannedOperation/GetNbrbPlannedOperation',
    getNBRBRatesForCurrency: 'api/Rates/GetNBRBRatesForCurrency',
    getFileListDocument: 'api/File/GetFileListDocument',
    updateCurrentUser: 'api/User/UpdateCurrentUser',
    uploadImageUser: 'api/FileUpload/UploadImageUser',
    versionConfig: 'api/File/GetVersionConfig',
    getBondRegister: 'api/BondRegister/GetBondRegister',
    getUnreadNewsCount: 'api/User/GetUnreadNewsCount',
    removeAllNotifyUnReadNews: 'api/User/RemoveAllNotifyUnReadNews',
    removeNotifyUnReadNews: 'api/User/RemoveNotifyUnReadNews',
    getCountBondRegisters: 'api/BondRegister/GetCountBondRegisters',
    getBondReleaseDecisions: 'api/BondRegister/GetBondReleaseDecisions',
    getBondRegisterStatuses: 'api/BondRegister/GetBondRegisterStatuses',
    getBondRegisterTypes: 'api/BondRegister/GetBondRegisterTypes',
    users: '/admin/users',
    guestList: '/main/guests',
    saveUser: 'api/User/SaveUser',
    saveGuest: 'api/User/SaveGuest',
    deleteUser: 'api/User/DeleteUser',
    getUsersFilter: 'api/User/GetUsersFilter',
    getRegisterUserList: 'api/User/GetRegisterUserList',
    getGuestsFilter: 'api/User/GetGuestsFilter',
    getUserById: 'api/User/GetUserById',
    getGuestById: 'api/User/GetGuestById',
    checkNameAndEmail: 'api/User/CheckNameAndEmail',
    currentDateTime: 'api/Settings/CurrentDateTime',
    deleteGuest: 'api/User/DeleteGuest',
    changeGuestPassword: 'api/User/ChanheGuestPassword',
    resetGuestPassword: 'api/User/ResetGuestPassword',
};


// WEBPACK FOOTER //
// ./common/constants/const-url.ts